import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconInstagram = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.58 7C13.541 7 7 13.545 7 21.586v20.832C7 50.458 13.545 57 21.586 57h20.832C50.458 57 57 50.455 57 42.414V21.58C57 13.541 50.455 7 42.414 7zM47 15a2 2 0 1 1-.001 4.001A2 2 0 0 1 47 15m-15 4c7.17 0 13 5.83 13 13s-5.831 13-13 13c-7.17 0-13-5.831-13-13s5.83-13 13-13m0 4a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9" })
});
export default SvgIconInstagram;
